import React, { useState } from 'react';

type ChildrenParams = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
};

export type ModalControllerProps = {
  content: (params: ChildrenParams) => React.ReactNode;
  modal: (params: ChildrenParams) => React.ReactNode | null;
};

const ModalControllerNV = ({ content, modal }: ModalControllerProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <>{content({ visible, setVisible })} </>
      {visible === true ? <>{modal({ visible, setVisible })} </> : null}
    </>
  );
};

export default ModalControllerNV;
